exports.KEY_LOCAL_STORAGE = {
  USER_TOKEN: 'user-token',
  SALDO: 's',
  QUANT_ITENS: 'qtd-itens',
  UID: 'uid',
  FBCLID: 'fbclid',
  VALORCREDITO: 'valorCredito',
};
